import React from 'react';
import { observer } from 'mobx-react';
import { Modal } from 'junto-ui';
import { ContentWrapper, Spinner, Text } from './ConnectionErrorModalStyles';
import { useStore } from '../../../../rootStore';

const ConnectionErrorModal = () => {
  const sharedStore = useStore('sharedStore');

  return (
    <Modal
      isOpen={sharedStore.displayConnectionModal}
      width="368px"
      height="432px"
      mobileFullScreen
      hideCloseButton
    >
      <ContentWrapper>
        <Spinner rotateColors={false} />
        <Text>Aguarde. Estamos carregando os dados para continuar…</Text>
      </ContentWrapper>
    </Modal>
  );
};

export default observer(ConnectionErrorModal);
